module.exports = __webpack_public_path__ + "img/1724832145653-bakwan.jpg.7fc72c3a.webp";